import { Injectable } from '@angular/core';
import { InstitutionDataService } from '../api/institution-data.service';

@Injectable({
  providedIn: 'root'
})

export class InstitutionService {
  constructor(private institutionDataService: InstitutionDataService) { }

  //Save Institution Form And Create Order
  public saveinstitutionFormandCreateOrder(data) {
    return this.institutionDataService.saveinstitutionFormandCreateOrder(data);
  }

  //Get All Institution
  public getAllinstitution(data) {
    return this.institutionDataService.getAllinstitution(data);
  }

  //Enable And Disable Institution
  public enableanddisableInstitution(data) {
    return this.institutionDataService.enableanddisableInstitution(data);
  }

  //Activate Institution
  public ActivateInstitution(data) {
    return this.institutionDataService.ActivateInstitution(data);
  }

  //Create Order
  public createOrder(gradeData) {
    return this.institutionDataService.createOrder(gradeData);
  }

  //get Institution By Login
  public getInstitutionByLogin() {
    return this.institutionDataService.getInstitutionByLogin();
  }

  //get Module By Institution Id
  public getModuleByInstitutionId(id) {
    return this.institutionDataService.getModuleByInstitutionId(id);
  }

  //get Institution By ID
  public getInstitutionByID(id) {
    return this.institutionDataService.getInstitutionByID(id);
  }

  //get Institution By ID
  public getAllModulesForInstitutionwithPaginationTest(data) {
    return this.institutionDataService.getAllModulesForInstitutionwithPaginationTest(data);
  }

  //Add Modules For Institution
  public AddModulesForInstitution(id) {
    return this.institutionDataService.AddModulesForInstitution(id);
  }

  //get Institution By ID
  public getModulesForInstitution(data) {
    return this.institutionDataService.getModulesForInstitution(data);
  }

  //getInProgressModulesByInstitutionId
  public getInProgressModulesByInstitutionId(data) {
    return this.institutionDataService.getInProgressModulesByInstitutionId(data);
  }

  //update Institution By ID
  public updateInstitutionByID(id, data) {
    return this.institutionDataService.updateInstitutionByID(id, data);
  }

  //getInstitutionByProfile
  public getInstitutionByProfile(data) {
    return this.institutionDataService.getInstitutionByProfile(data);
  }
  // getStudentDetailsForCompletedModules
  public getStudentDetailsForCompletedModules(data) {
    return this.institutionDataService.getStudentDetailsForCompletedModules(data);
  }
  // getAllEventsByType
  public getAllEventsByType(data) {
    return this.institutionDataService.getAllEventsByType(data);
  }

  // Get All Language 
  public getAllLanguages() {
    return this.institutionDataService.getAllLanguages();
  }
  // Get All Institution Student Count
  public getAllinstitutionStudentCount(data) {
    return this.institutionDataService.getAllinstitutionStudentCount(data);
  }
}